<template>
  <div class="footer">
     <span>
<!--       <a href="http://www.medtrum.com/index.php/abouts">{{ $t('contact us') }} </a>-->
<!--           <a v-if="!isEU" href="http://www.medtrum.com/privacy_policy.html">|  {{ $t('Privacy Policy') }} </a>-->
<!--           <a v-if="!isEU" href="http://www.medtrum.com/terms_of_use.html">|  {{ $t('Terms of Use') }} | </a>-->
<!--           <a v-if="isEU" href="http://www.medtrum.co.uk/privacy_policy.html">|  {{ $t('Privacy Policy') }} </a>-->
<!--           <a v-if="isEU" href="http://www.medtrum.co.uk/terms_of_use.html">|  {{ $t('Terms of Use') }} | </a>-->
              <a :href="contactURL">{{ $t('contact us') }} </a>
              <a :href="privacyURL">|  {{ $t('Privacy Policy') }} </a>
              <a :href="termsOfUseURL">|  {{ $t('Terms of Use') }} | </a>

             {{$t('copyright')}}<br/>
          <a v-show="isZh" target=_blank href="http://beian.miit.gov.cn/"> 沪ICP备08013753号-3  </a>
          <img v-show="isZh" src="/static/beian.png" />
          <a v-show="isZh" target=_blank href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"> 沪公网安备 31011502014155号 </a>
     </span>
  </div><!--footer 结束-->
</template>

<script>
  import auth from '../../auth/auth'
  export default{
    data:function () {
      return{
        isZh:false,
        isEU:true,
        contactURL:'',
        privacyURL:'',
        termsOfUseURL:''
      }
    },
    computed:{
      updateLocCode(){
        console.log('compute updateLocCode:');
        return this.$store.state.loc_code;
      }
    },
    watch:{
      updateLocCode(val){
        // this.$i18n.locale = val;
        console.log('watch updateLocCode:', val);
        let host=auth.getOuterHost();
        this.contactURL = host+'/contact.html';
        this.privacyURL = host+'/privacy_policy.html';
        this.termsOfUseURL = host + '/terms_of_use.html';
      }
    },
    mounted(){
      this.isZh = (sessionStorage.getItem('language')==='zh')?true:false;
      let countryIndex=localStorage.getItem('index');
      console.info('countryIndex:'+countryIndex);
      if (1==countryIndex || 6==countryIndex || 14==countryIndex) {
        this.isEU=false;
      }
      setTimeout(()=>{
        let host=auth.getOuterHost();
        this.contactURL = host+'/contact.html';
        this.privacyURL = host+'/privacy_policy.html';
        this.termsOfUseURL = host + '/terms_of_use.html';
      }, 50)
    }
  }
</script>

<style scoped>
  .footer{
    height:21px;
    width:80%;
    margin:5% auto 0;
    font-size:18px;
    color:rgba(246,248,251,0.90);
    letter-spacing:-0.54px;
    text-align:center;
    font-family: SFUIText-Regular;
  }
  .footer a{
    color:rgba(246,248,251,0.90);
    text-decoration: none;
  }
  .footer a:hover{
    color:#0090D3;
  }
</style>



// WEBPACK FOOTER //
// Signfooter.vue?4c352a41